import React from "react";
import { Box } from "@mui/material";
import TextCapsule from "./TextCapsule";

const ListSelector = (props) => {
  const { list, handleItemSelection, listDirection } = props;
  const selection = list.map((el) => (
    <TextCapsule
      title={el.name + " Liability insurance"}
      click={() => handleItemSelection(el.id)}
      index={el.id}
      key={el.id}
    />
  ));
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: listDirection ? listDirection : "column",
      }}
    >
      {selection}
    </Box>
  );
};

export default ListSelector;
